var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolInvert = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  x: 4,
  y: 5,
  width: 20,
  height: 18,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 23H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h8v3a6 6 0 1 0 0 12v3ZM14 8a6 6 0 1 1 0 12Z",
  fill: "currentColor"
}))));
export { SvgToolInvert as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-invert.svg";